/* Native <details> accordion enhancement: only one open per group at a time. */
(function () {
  document.querySelectorAll('[data-accordion]').forEach((group) => {
    const rows = group.querySelectorAll('details');
    rows.forEach((row) => {
      row.addEventListener('toggle', () => {
        if (row.open) {
          rows.forEach((r) => { if (r !== row) r.open = false; });
        }
      });
    });
  });
})();
